import { ApiResponse } from '@/models/ApiResponse';
import {
  FXRollValueDatesRequestPayload,
  FXRollValueDatesResponse,
  FXRollsListRequestPayload,
  FXRollsListResponse,
  FXRollsDeleteRequestPayload,
  FXRollsDeleteResponse,
  FXRollsSubmitRequestPayload,
  FXRollsSubmitResponse,
  FXRollGroupingRulesResponse,
} from '@/pages/TransactionRolling/store/types';
import { AxiosInstance } from 'axios';
import {
  FXRollsGenerateRequestPayload,
  FXRollsGenerateResponse,
} from '@/pages/TransactionRolling/store/types';


export default class TransactionRollingAPI {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async fetchFxRollValueDates(
    payload: FXRollValueDatesRequestPayload,
  ): Promise<ApiResponse<FXRollValueDatesResponse>> {
    const res = await this.client.post<ApiResponse<FXRollValueDatesResponse>>(
      '/v2/fund-level-hedging/fx/rolls/value_dates/',
      payload,
    );
    return res.data;
  }

  async generateFxRolls(
    payload: FXRollsGenerateRequestPayload,
  ): Promise<ApiResponse<FXRollsGenerateResponse>> {
    const res = await this.client.post<ApiResponse<FXRollsGenerateResponse>>(
      '/v2/fund-level-hedging/fx/rolls/generate/',
      payload,
    );
    return res.data;
  }

  async listFxRolls(
    payload: FXRollsListRequestPayload,
  ): Promise<ApiResponse<FXRollsListResponse>> {
    const res = await this.client.post<ApiResponse<FXRollsListResponse>>(
      '/v2/fund-level-hedging/fx/rolls/list/',
      payload,
    );
    return res.data;
  }

  async deleteFxRolls(
    payload: FXRollsDeleteRequestPayload,
  ): Promise<ApiResponse<FXRollsDeleteResponse>> {
    const res = await this.client.post<ApiResponse<FXRollsDeleteResponse>>(
      '/v2/fund-level-hedging/fx/rolls/delete/',
      payload,
    );
    return res.data;
  }

  async submitFxRolls(
    payload: FXRollsSubmitRequestPayload,
  ): Promise<ApiResponse<FXRollsSubmitResponse>> {
    const res = await this.client.post<ApiResponse<FXRollsSubmitResponse>>(
      '/v2/fund-level-hedging/fx/rolls/submit/',
      payload,
    );
    return res.data;
  }

  async fetchGroupingRules(): Promise<ApiResponse<FXRollGroupingRulesResponse>> {
    const res = await this.client.get<ApiResponse<FXRollGroupingRulesResponse>>(
      '/v2/fund-level-hedging/fx/rolls/grouping-rules/',
    );
    return res.data;
  }

}
